export const ROUTE_HOME = '/';

export const ROUTE_TEAMS = '/t';
export const ROUTE_TEAM = `${ROUTE_TEAMS}/:teamId`;
export const ROUTE_TEAM_PROJECTS = `${ROUTE_TEAM}/p`;
export const ROUTE_TEAM_PROJECT = `${ROUTE_TEAM_PROJECTS}/:projectId`;
export const ROUTE_TEAM_PROJECT_SCENES = `${ROUTE_TEAM_PROJECT}/s`;
export const ROUTE_TEAM_PROJECT_SCENE = `${ROUTE_TEAM_PROJECT_SCENES}/:sceneId`;
export const ROUTE_TEAM_PROJECT_SCENE_VIEWER = `${ROUTE_TEAM_PROJECT_SCENE}/v/:viewerId`;


console.log( ROUTE_TEAMS );
console.log( ROUTE_TEAM );
console.log( ROUTE_TEAM_PROJECTS );
